import { LoaderCentered } from '@modules/components';
import { Acl } from '@modules/permissions/Acl';
import { lazy, Suspense } from 'react';

const SalesBoardMfe = lazy(() => import('./SalesBoardMfe'));

const SalesView = () => {
  return (
    <Acl require="offer:view">
      <Suspense fallback={<LoaderCentered />}>
        <SalesBoardMfe />
      </Suspense>
    </Acl>
  );
};
export default SalesView;
